import { formatRestrictionDate } from "./formatters";
import { AUDIT_ACTIONS, AUDIT_ACTION_LABELS } from "../constants";

export function formatUpdatedAgo(date) {
  if (!date) return null;

  const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);

  if (seconds < 60) return "Just now";
  if (seconds < 3600) return `${Math.floor(seconds / 60)} minutes ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} hours ago`;
  if (seconds < 86400 * 7) return `${Math.floor(seconds / 86400)} days ago`;

  return formatRestrictionDate(date);
}

export function mapFlagToRestriction(flag) {
  if (!flag) return null;

  return {
    id: flag._id,
    start: flag.startsAt,
    end: flag.endsAt,
    reason: flag.reason,
    createdBy: flag.createdBy?.displayName ?? flag.createdBy ?? "Unknown",
    editedBy: (flag.editedBy ?? [])
      .filter((actor) => actor !== flag.createdBy)
      .filter((actor, idx, arr) => arr.indexOf(actor) === idx),
    updatedAgo: formatUpdatedAgo(flag.updatedAt),
    isRevoked: !!flag.revokedBy,
  };
}

export function mapFlagsToAuditHistory(flags) {
  if (!flags?.length) return [];

  return flags.map((flag) => {
    const action =
      flag.action ??
      (flag.revokedBy
        ? AUDIT_ACTIONS.TURNED_ON
        : flag.updatedAt !== flag.createdAt
          ? AUDIT_ACTIONS.EDITED_DETAILS
          : AUDIT_ACTIONS.TURNED_OFF);

    return {
      id: flag._id,
      time: formatRestrictionDate(flag.createdAt),
      action,
      label: AUDIT_ACTION_LABELS[action] ?? action,
      details: flag.revokeReason ?? flag.reason ?? "—",
      by: flag.createdBy?.displayName ?? flag.createdBy ?? "Unknown",
    };
  });
}

export function getScopeCopy(scope) {
  if (scope === "district") {
    return {
      heading: "App ON/OFF Controls",
      subHeading:
        "This section allows district leaders to turn the app OFF for your district so that students cannot use it for a certain time period (such as summer break).",
      toggleLabel: "District-wide App ON/OFF Switch",
      toggleHint:
        "When turned off, students across all schools cannot access the app.",
    };
  }

  return {
    heading: "App ON/OFF Controls",
    subheading:
      "This section allows school leaders to turn the app OFF for your school so that students cannot use it for a certain time period (such as summer break).",
    toggleLabel: "School-wide App ON/OFF Switch",
    toggleHint:
      "When turned off, students in this school cannot access the app.",
  };
}
